import React from 'react'
import { connect } from 'react-redux'
import {
  Grid,
  Typography,
  CardContent,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from '@mui/material'
import { uploadInventoryFile } from '../../../store/Procurement/actionCreator'
import {
  handleFireflySendEvent,
  handleFireflySendClickEvent,
} from '../../Utils/FireFlyVnextHelpers'

export class inventoryCheckerTab extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      requestor: '',
      shipment: '',
      a_or_b: '',
      file: null,
      reviewType: 'Review',
      requestNumber: '',
      poException: false,
      buttonEnabled: false,
    }
    this.fileInputRef = React.createRef()
  }

  async componentDidMount() {
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Inventory Checker',
        'Inventory Checker Tab Load',
        userInfo,
      )
    }
  }

  hasRequiredPermissions = () => {
    const { userInfo } = this.props
    return userInfo.memberOf.includes('APP-OAUTH2-ZIPTIE-RD-PROCUREMENT')
  }

  validateRequestNumber = (value) => {
    return value.trim() === value && value.trim().length > 0
  }

  validateForm = () => {
    const { reviewType, requestNumber, file } = this.state

    if (reviewType === 'Review') {
      this.setState({ buttonEnabled: file !== null })
    } else if (reviewType === 'Cancel') {
      this.setState({
        buttonEnabled:
          requestNumber !== '' && this.validateRequestNumber(requestNumber),
      })
    } else if (reviewType === 'New' || reviewType === 'Update') {
      this.setState({
        buttonEnabled:
          file !== null &&
          requestNumber !== '' &&
          this.validateRequestNumber(requestNumber),
      })
    } else {
      this.setState({ buttonEnabled: false })
    }
  }

  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target
    this.setState(
      {
        [name]: type === 'checkbox' ? checked : value,
      },
      () => {
        this.validateForm()
      },
    )
  }

  handleDropdownChange = (e) => {
    const { value } = e.target
    this.setState(
      {
        reviewType: value,
        requestNumber: '',
        poException: false,
        a_or_b: '',
        shipment: '',
        file: null,
        responseMessage: '',
        buttonEnabled: false,
      },
      () => {
        this.validateForm()
      },
    )
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = ''
    }
  }

  handleFileChange = (e) => {
    this.setState({ file: e.target.files[0] }, () => {
      this.validateForm()
    })
  }

  handleSubmit = () => {
    const { a_or_b, shipment, file, reviewType, requestNumber, poException } =
      this.state
    const { userInfo, dispatch } = this.props

    if (
      (reviewType === 'New' ||
        reviewType === 'Update' ||
        reviewType === 'Cancel') &&
      !this.validateRequestNumber(requestNumber)
    ) {
      alert(
        'Please enter a valid request number without trailing spaces or special characters.',
      )
      return
    }

    if (reviewType !== 'Cancel' && !file) {
      alert('Please upload a file.')
      return
    }

    this.setState({ loading: true })

    handleFireflySendClickEvent(
      'CLICK',
      'Inventory Checker',
      'Inventory Checker - Submit',
      userInfo,
    )

    const formData = new FormData()
    formData.append('requestor', userInfo.email)
    formData.append('review_type', reviewType)

    if (reviewType !== 'Review') {
      formData.append('request_number', requestNumber.trim())
    }
    if (reviewType === 'New' || reviewType === 'Update') {
      formData.append('po_exception', poException)
    }
    if (reviewType !== 'Cancel') {
      formData.append('shipment', shipment)
      formData.append('a_or_b', a_or_b)
      formData.append('rawFile', file)
    }

    dispatch(uploadInventoryFile(formData))
      .then((response) => {
        this.setState({
          responseMessage: response,
          loading: false,
        })

        const isSuccess =
          typeof response === 'string'
            ? !response.toLowerCase().includes('error') &&
              !response.toLowerCase().includes('failed')
            : response &&
              !response.error &&
              response !== 'An unexpected error occurred.'

        if (isSuccess) {
          this.setState({
            a_or_b: '',
            shipment: '',
            file: null,
            requestNumber: '',
            poException: false,
            buttonEnabled: false,
          })
          if (this.fileInputRef.current) {
            this.fileInputRef.current.value = ''
          }
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data
            : 'An unexpected error occurred.'
        this.setState({
          responseMessage: errorMessage,
          loading: false,
        })
      })
  }

  render() {
    const {
      a_or_b,
      shipment,
      responseMessage,
      reviewType,
      requestNumber,
      poException,
      loading,
    } = this.state
    const hasPermissions = this.hasRequiredPermissions()

    return (
      <CardContent
        style={{
          height: '90%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          overflowY: 'auto',
          position: 'relative',
        }}
      >
        {loading && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
            }}
          >
            <div style={{ textAlign: 'center' }}>
              <CircularProgress size={60} />
              <Typography variant="h6" style={{ marginTop: '16px' }}>
                Processing...
              </Typography>
            </div>
          </div>
        )}
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12 }}>
            <FormControl style={{ width: '50%' }}>
              <InputLabel>Review Type</InputLabel>
              <Select
                value={reviewType}
                onChange={this.handleDropdownChange}
                label="Review Type"
              >
                <MenuItem value="Review">Review</MenuItem>
                <MenuItem
                  value="New"
                  disabled={!hasPermissions}
                  style={{ color: hasPermissions ? 'inherit' : '#ccc' }}
                >
                  New
                </MenuItem>
                <MenuItem
                  value="Update"
                  disabled={!hasPermissions}
                  style={{ color: hasPermissions ? 'inherit' : '#ccc' }}
                >
                  Update
                </MenuItem>
                <MenuItem
                  value="Cancel"
                  disabled={!hasPermissions}
                  style={{ color: hasPermissions ? 'inherit' : '#ccc' }}
                >
                  Cancel
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {(reviewType === 'New' ||
            reviewType === 'Update' ||
            reviewType === 'Cancel') && (
            <Grid item size={{ xs: 12 }}>
              <TextField
                label="Request Number"
                name="requestNumber"
                value={requestNumber}
                onChange={this.handleInputChange}
                required
                sx={{
                  input: { color: 'black' },
                }}
                style={{ width: '50%' }}
                helperText="No trailing spaces or special characters allowed"
                error={
                  requestNumber && !this.validateRequestNumber(requestNumber)
                }
              />
            </Grid>
          )}

          {(reviewType === 'New' || reviewType === 'Update') && (
            <Grid item size={{ xs: 12 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="poException"
                    checked={poException}
                    onChange={this.handleInputChange}
                    disabled={!hasPermissions}
                  />
                }
                label="On PO Exception"
                style={{ color: hasPermissions ? 'inherit' : '#ccc' }}
              />
            </Grid>
          )}

          {reviewType !== 'Cancel' && (
            <>
              <Grid item size={{ xs: 12 }}>
                <TextField
                  label="A or B (Leave blank if you want to check the whole file)"
                  name="a_or_b"
                  value={a_or_b}
                  onChange={this.handleInputChange}
                  sx={{
                    input: { color: 'black' },
                  }}
                  style={{ width: '50%' }}
                />
              </Grid>
              <Grid item size={{ xs: 12 }}>
                <TextField
                  label="Shipment Number (Leave blank if you want to check the whole file)"
                  name="shipment"
                  value={shipment}
                  onChange={this.handleInputChange}
                  fullWidth
                  sx={{
                    input: { color: 'black' },
                  }}
                  style={{ width: '50%' }}
                />
              </Grid>
              <Grid item size={{ xs: 12 }}>
                <input
                  key={`file-input-${reviewType}`}
                  ref={this.fileInputRef}
                  type="file"
                  accept=".xlsx"
                  onChange={this.handleFileChange}
                  style={{ marginTop: '16px' }}
                />
              </Grid>
            </>
          )}

          <Grid item size={{ xs: 12 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleSubmit}
              disabled={!this.state.buttonEnabled}
            >
              Submit
            </Button>
          </Grid>
          {responseMessage && (
            <Grid item size={{ xs: 12 }}>
              <Typography variant="body1" color="textSecondary">
                {typeof responseMessage === 'string'
                  ? responseMessage
                  : JSON.stringify(responseMessage)}
              </Typography>
            </Grid>
          )}

          <Grid item size={{ xs: 12 }}>
            <Typography variant="body2" style={{ marginTop: '20px' }}>
              <a href="https://targetonline.sharepoint.com/:x:/r/sites/ogrp-tts-planning-and-enablement/Shared%20Documents/Procurement/Procurement%20Working%20Documents/Kitting%20Document%20Template%20for%20Upload.xlsx?download=1">
                Link to template
              </a>
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch,
})

export default connect(
  (state) => ({
    userInfo: state.auth.userInfo,
  }),
  mapDispatchToProps,
)(inventoryCheckerTab)
